import { useRoute } from "vue-router";
import { computed, ref } from "vue";
import { t } from "@/i18n";

/**
 *  Composable to handle logic for confirmation (based on address):
 *
 *  /review-confirm/:projectUuid/:reviewUuid?quickConfirm=true
 * */

export function useReviewConfirmation(props, reviewObservable) {
    const reviewConfirmError = ref("");
    const route = useRoute();
    const { reviewUuid } = route.params;
    const isReviewConfirmation = computed(() => Boolean(reviewUuid));
    const fireQuickConfirmation = computed(
        () => isReviewConfirmation.value && Boolean(route.query.quickConfirm)
    );

    // We can Promisify in future (that might be async from service layer (ajax request))
    // But we should remember about RichTextBox markPristine() option to be settled down.
    // Promise.resolve().then(() => {
    if (isReviewConfirmation.value) {
        const foundReview = (props?.wall?.testimonials || []).find((t) => t.uuid === reviewUuid);
        if (!foundReview) {
            reviewConfirmError.value = t("r_love.review_form.invalid_not_found", {
                slug: reviewUuid,
            });
        }
        if (foundReview?.confirmed) {
            reviewConfirmError.value = t("r_love.review_form.invalid_already_confirmed", {
                slug: reviewUuid,
            });
        }
        Object.assign(reviewObservable, foundReview);
    }
    // });

    return { isReviewConfirmation, reviewConfirmError, fireQuickConfirmation };
}
